module.exports = __webpack_public_path__ + "media/src/images/web/web-smtx-ui-3e94ebb88989b0122ee6b7373e6e5f4c.png";